import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';

import { COMMON_TEXT } from '@shared/constants/text';

import { SHARED_COMPONENTS_TEXT } from '../constants';

export interface ConfirmOptions {
  message: string;
  header?: string;
  acceptLabel?: string;
  rejectLabel?: string;
  danger?: boolean;
  /** A fixed width (e.g. "26rem"); long messages wrap. Default: as wide as the message. */
  width?: string;
}

/** Mount once (AppProviders). Replaces the browser's native `confirm()`. */
export function ConfirmHost() {
  return <ConfirmDialog />;
}

/** `if (await confirm({ message: 'Delete?' , danger: true })) { … }` */
// eslint-disable-next-line react-refresh/only-export-components -- imperative API beside its host
export function confirm({
  message,
  header = SHARED_COMPONENTS_TEXT.confirm.header,
  acceptLabel = SHARED_COMPONENTS_TEXT.confirm.accept,
  rejectLabel = COMMON_TEXT.actions.cancel,
  danger = false,
  width,
}: ConfirmOptions): Promise<boolean> {
  return new Promise((resolve) => {
    confirmDialog({
      message,
      header,
      acceptLabel,
      rejectLabel,
      // An icon beside the message: a warning for destructive actions, else a question.
      icon: danger ? 'pi pi-exclamation-triangle' : 'pi pi-question-circle',
      className: danger ? 'confirm-danger' : undefined,
      style: width ? { width, maxWidth: 'calc(100vw - 32px)' } : undefined,
      acceptClassName: danger ? 'p-button-danger' : undefined,
      rejectClassName: 'p-button-outlined',
      defaultFocus: 'reject',
      accept: () => {
        resolve(true);
      },
      reject: () => {
        resolve(false);
      },
      onHide: () => {
        resolve(false);
      },
    });
  });
}
